// extracted by mini-css-extract-plugin
export default {"onboardingPage":"styles_onboardingPage__viQj4"};